export default function () {
  const today = new Date();
  // Subtract 18 years from the current year
  const eighteenYearsAgo = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );

  // Convert to ISO string (YYYY-MM-DD) which ion-datetime expects
  return eighteenYearsAgo.toISOString().split('T')[0];
}
